import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import EmojiPicker from "emoji-picker-react"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import useOnClickOutside from "../../hooks/useOnClickOutside"

interface RewardEmojiPickerStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useRewardEmojiPicker = create<RewardEmojiPickerStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

type Props = {
  emoji: string | null
}

const RewardEmojiPickerButton = ({ emoji }: Props) => {
  const { onOpen } = useRewardEmojiPicker()
  const { t } = useTranslation()
  return (
    <button onClick={onOpen}>
      <div className="flex flex-row justify-between items-center border border-borderPrimary rounded-md p-3 py-2 bg-white">
        <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
          {t("REWARD_ICON")}
        </Typography>
        <div className="flex flex-row items-center gap-2">
          {emoji && (
            <Typography
              variant="bodySmall"
              style={{ fontSize: "50px", lineHeight: "50px" }}
            >
              {emoji}
            </Typography>
          )}
          <FontAwesomeIcon
            icon={faChevronRight}
            color={JoonUIColor.icon.neutral}
            fontSize={16}
          />
        </div>
      </div>
    </button>
  )
}

const RewardEmojiPicker = ({ setEmoji }: { setEmoji: any }) => {
  const { isOpen, onClose } = useRewardEmojiPicker()
  const emojiPickerRef = useRef<any>()
  useOnClickOutside(emojiPickerRef, onClose)

  if (!isOpen) return <></>

  return (
    <>
      <div className="emoji-picker" ref={emojiPickerRef}>
        <EmojiPicker
          onEmojiClick={(val) => {
            onClose()
            setEmoji(val.emoji)
          }}
        />
      </div>
    </>
  )
}

export { RewardEmojiPicker, RewardEmojiPickerButton }
